import { Outlet, useNavigate } from "react-router-dom"
import { Toaster } from "@/components/ui/toaster"
import { useDispatch, useSelector } from "react-redux"
import ct from "@constants/"
import { useEffect } from "react"
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar"
import {
  setNewThread,
  setThreadDetails,
} from "@/services/store/slices/chats.slice"
// import ModeToggle from "@/components/layout/header/theme-switch"
import { ReactQueryDevtools } from "@/lib/devtools"
// import { WebSocketProvider } from "@/context/WebSocketContext"
import AppSidebar from "./app-sidebar"
import UserNav from "./header/user-nav"
// import LanguageNav from "./header/language-nav"

export default function MainLayout() {
  const store = useSelector((st) => st[ct.store.USER_STORE])
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    if (store.isAuthenticated) {
      return
    }
    // route to login page
    navigate(`/${ct.route.auth.LOGIN}`, { replace: true })
  }, [store, navigate])

  useEffect(() => {
    if (!store.isAuthenticated) {
      return () => {}
    }

    let reconnectTimeout

    const connectWebSocket = () => {
      // check device_id exists
      if (!localStorage.getItem("device_id")) {
        localStorage.setItem("device_id", Math.floor(Math.random() * 10000) + 1)
      }

      const userId = "chats"
      const deviceID = localStorage.getItem("device_id")
      const ws = new WebSocket(
        `${import.meta.env.VITE_WEBSOCKET_SERVER}/v1/users/${userId}/notifications/${deviceID}`
      )

      ws.onopen = () => {
        console.log("WebSocket Connected")
      }

      ws.onmessage = (event) => {
        const notification = JSON.parse(event.data)
        if ("status" in notification) {
          console.log("WebSocket Received notification: Status", notification)
          dispatch(setThreadDetails(notification))
        } else {
          console.log("WebSocket Received notification: Message", notification)
          dispatch(setNewThread(notification))
        }
      }

      ws.onerror = (error) => {
        console.error("WebSocket error:", error)
      }

      ws.onclose = () => {
        console.log(
          "WebSocket disconnected, attempting to reconnect in 1 minute..."
        )
        reconnectTimeout = setTimeout(connectWebSocket, 60000) // 1 minute
      }

      return ws
    }

    const ws = connectWebSocket()

    return () => {
      ws.close()
      if (reconnectTimeout) {
        clearTimeout(reconnectTimeout)
      }
    }
  }, [dispatch, store.isAuthenticated])

  return (
    // <WebSocketProvider>
    <SidebarProvider>
      <AppSidebar />
      <main className="min-h-screen w-full">
        <div className="sticky top-0 z-50 w-full dark:shadow-secondary flex items-center justify-between p-4 bg-white dark:bg-[#020817] border-b dark:border-slate-800">
          <div className="flex items-center gap-4">
            <SidebarTrigger />
          </div>
          <div className="flex items-center gap-2 ml-auto">
            {/* <LanguageNav /> */}
            {/* <ModeToggle /> */}
            <UserNav />
          </div>
        </div>
        <div className="p-4 dark:bg-[#020817]">
          <Toaster />
          <Outlet />
          <ReactQueryDevtools />
        </div>
      </main>
    </SidebarProvider>
    // </WebSocketProvider>
  )
}
